import {
  useWebsocketManager,
  type WebsocketManagerHookOptions,
} from '@iconik-io/shared-lib/src/react/components/shared/websocket_manager/use_websocket_manager';
import { getStorageCredentials } from '@iconik-io/shared-lib/src/redux/middlewares/storage/credentials';
import { getWebsocketUrl } from '@iconik-io/shared-lib/src/utils/websocket/get_websocket_url';

import { useAppSelector } from '../../store/react_redux_typed';

type Props = Omit<WebsocketManagerHookOptions, 'getWebsocketUrl'> & {
  pathEntity: string;
  pathEntityId?: string;
};

export function WebsocketManagerWeb(props: Props) {
  const shareAuth = useAppSelector((state) => state.share.shareAuthLogin);
  const appHost = useAppSelector((state) => state.appReducer.host) || undefined;

  useWebsocketManager({
    ...props,
    getWebsocketUrl: () => {
      const { appId, token } = getStorageCredentials();

      let websocketUrl;

      if (shareAuth?.app_id && shareAuth?.token) {
        websocketUrl = getWebsocketUrl({
          appId: shareAuth.app_id,
          shareToken: shareAuth.token,
          pathEntity: props.pathEntity,
          pathEntityId: props.pathEntityId,
          appHost,
        });
      }

      if (appId && token) {
        websocketUrl = getWebsocketUrl({
          appId,
          token,
          pathEntity: props.pathEntity,
          pathEntityId: props.pathEntityId,
          appHost,
        });
      }

      return websocketUrl;
    },
  });

  return null;
}
